import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import { ThemeContext } from '../../../context/theme.context';

import ShiftWorkbenc from '../Shiftworkbench';
import Summary from '../Summary/Summary';
import Dashboard from '../Dashboard/Dashboard';

interface IProps {}
interface IState {
  currentTab: any;
}
class ShiftWorkbenchTabs extends React.Component<IProps, IState> {
  private headerText: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private current_tab: number = 0;
  private tabObj: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      currentTab: 0,
    };
    this.headerText = [
      { text: 'Summary' },
      { text: 'Shift Workbench' },
      { text: 'Dashboard' },
    ];
  }
  content0() {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <Summary />
          </div>
        </div>
      </div>
    );
  }
  // content1() {
  //   return (
  //     <div>
  //       <div className='row mt-3 p-2'>
  //         <div className='col-md-12'>
  //           <ShiftWorkbenc />
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  content2() {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <Dashboard />
          </div>
        </div>
      </div>
    );
  }
  componentDidMount() {
    this.tabObj.element.classList.add('e-fill');
  }
  componentDidUpdate() {
    if (this.context.isChangeCurrentTabEvent) {
      this.current_tab = 1;
      this.context.setChangeCurrentTabEvent(
        false,
        this.context.currentTabEventIndex
      );
    }
  }
  select(e:any) {
    if (e.isSwiped) {
        e.cancel = true;
    }
}
  render() {
    return (
      <TabComponent
        selecting={this.select.bind(this)}
        heightAdjustMode='Auto'
        selectedItem={this.current_tab}
        ref={(tab) => (this.tabObj = tab)}
        selected={(args: any) => {
          this.current_tab = args.selectingIndex;
        }}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={this.headerText[0]}
            content={this.content0}
          />
          {/* <TabItemDirective
            header={this.headerText[1]}
            content={this.content1}
          /> */}
          <TabItemDirective
            header={this.headerText[2]}
            content={this.content2}
          />
        </TabItemsDirective>
      </TabComponent>
    );
  }
}
export default ShiftWorkbenchTabs;
